import React, { Component, Fragment } from "react";
import styled from "styled-components";
import { Link, navigate } from "@reach/router";
import FontAwesome from "react-fontawesome";
import { connect } from "react-redux";
import ModalComponent from "./Modal";
import Profile from "./Profile";
import {
  authInput,
  SignupUserNamePass,
  LoginUserNamePass,
  doFacebookLogin,
  resetAuthFields,
  modalOpen,
  searchPerformed,
  resetSearchResults,
  searchInputWholeWord,
  showAdvancedData,
} from "../store/actions";

const MainHeader = styled.header`
  grid-area: header;
  background: linear-gradient(to top, #030101 00%, #6c1021 100%);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const HeaderText = styled(Link)`
  font-family: "Open Sans", sans-serif;
  font-weight: bold;
  font-size: 2rem;
  color: white;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const HeaderTextContainer = styled.div`
  margin: 1rem;
`;

const StyledIconsDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const UserIconDiv = styled.div`
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: solid 2px white;
  text-align: center;
  background-color: white;
  margin: 1rem;
  transition: opacity 0.5s;
  background-image: ${(props) => props.styleProp};
  &:hover {
    opacity: 0.5;
    cursor: pointer;
  }
`;

const UserIcon = styled(FontAwesome)`
  font-size: 2rem;
  line-height: 3rem;
  color: black;
`;

const MagnifyingGlassIcon = styled(FontAwesome)`
  font-size: 3rem;
  line-height: 3rem;
  color: white;
  margin-right: 1rem;
  transition: opacity 0.5s;
  &:hover {
    opacity: 0.5;
    cursor: pointer;
  }
`;

const StyledInputDivContainer = styled.div`
  display: grid;
  justify-items: center;
  grid-template-columns: 1fr;
  justify-content: center;
`;
const StyledInputDiv = styled.div`
  // background-color: grey;
  overflow: hidden auto;
  display: grid;
  justify-items: center;
  justify-content: center;
  grid-template-columns: 1fr;
  grid-template-rows: 3rem 4rem 2rem 4rem 2rem 4rem 4rem 4rem 4rem 4rem;
`;
const StyledInputDivSignUp = styled.div`
  // background-color: grey;
  overflow: hidden auto;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 3rem 4rem 2rem 4rem 2rem 4rem 2rem 2rem 4rem 4rem;
`;

const StyledHeaderText = styled.h2`
  font-family: "Open Sans", sans-serif;
  justify-self: center;
`;

const SearchInput = styled.input`
  margin: 0;
  padding: 0;
  width: 22rem;
  height: 3rem;
  border-radius: 3rem;
  border: none;
  text-indent: 1rem
  font-size: 1.5rem;
  &:focus {
    outline: none;
  }
  @media (max-width: 700px) {
    width: 18rem;
    }
`;

const StyledSignupLoginButton = styled.button`
  color: white;
  background-color: ${(props) => props.color};
  margin-top: 2rem;
  margi-bottom: 2rem;
  padding: 0;
  width: 22rem;
  height: 3rem;
  border-radius: 3rem;
  border: none;
  font-size: 1rem;
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.5;
  }
  @media (max-width: 700px) {
    width: 18rem;
  }
`;

const StyledInputLabel = styled.label`
  margin-left: 1rem;
  padding: 0;
`;

const BodyText = styled.p`
  font-family: "Open Sans", sans-serif;
  color: white;
  > strong {
    font-size: 2rem;
    @media (max-width: 700px) {
      font-size: 1.5rem;
    }
  }
`;

const FilterSearchButton = styled.button`
  top: 2rem;
  position: relative;
  height: 3.2rem;
  width: 3.2rem;
  border-radius: 5rem;
  background-color: red;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  justify-self: center;
  border: none;
  transition: all 0.5s;
  &::after {
    content: 'X';
    color: white;
    font-size: 1rem;
  }
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.5;
    cursor: pointer;
  }
  }
`;

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      closedModalOnLogin: false,
      showLogin: false,
      profilePic: "",
    };
  }

  componentDidMount() {
    const { showSignup } = this.props;
    if (showSignup) {
      this.toggleModal();
    }
    if (!this.state.profilePic) {
      if (this.props.auth.userInfo) {
        if (this.props.auth.userInfo.photoURL) {
          this.setState({
            profilePic: `url('${this.props.auth.userInfo.photoURL}')`,
          });
        }
      }
    }
  }

  componentDidUpdate() {
    const { showSignup } = this.props;
    if (this.props.auth.isLoggedIn && !this.state.closedModalOnLogin) {
      this.setState({ modalIsOpen: false, closedModalOnLogin: true });
    }
    if (showSignup && !this.state.modalIsOpen) {
      this.toggleModal();
    }
    if (!this.state.profilePic) {
      if (this.props.auth.userInfo) {
        if (this.props.auth.userInfo.photoURL) {
          this.setState({
            profilePic: `url('${this.props.auth.userInfo.photoURL}')`,
          });
        }
      }
    }
    if (this.state.profilePic && !this.props.auth.isLoggedIn) {
      this.setState({ profilePic: "" });
    }
  }

  toggleModal = () => {
    const {
      showSignup,
      resetAuthFields,
      modalOpen,
      music: { modalIsOpen },
    } = this.props;
    if (showSignup) {
      resetAuthFields();
      modalOpen(true);
    } else {
      resetAuthFields();
      modalOpen(!modalIsOpen);
      this.setState((prevState) => ({ modalIsOpen: !this.state.modalIsOpen }));
    }
  };

  toggleModalGoHome = () => {
    resetAuthFields();
    this.setState({ modalIsOpen: !this.state.modalIsOpen });
    // after switch to reach router, add push to go home here
  };

  toggleShowLogin = () => {
    resetAuthFields();
    modalOpen(!this.props.music.modalIsOpen);
    this.setState((prevState) => ({ showLogin: !prevState.showLogin }));
  };

  _defaultModalContents = () => (
    <Fragment>
      <StyledInputDivContainer>
        <StyledInputDivSignUp>
          <StyledHeaderText>YOU'RE NOT LOGGED IN.</StyledHeaderText>
          <BodyText style={{ justifySelf: "center" }}>
            No account? Signup below
          </BodyText>
          <StyledInputLabel htmlFor="email">Email</StyledInputLabel>
          <SearchInput
            name="email"
            id="email"
            placeholder="Email"
            onChange={this.props.authInput}
            value={this.props.auth.email}
          />
          <StyledInputLabel htmlFor="userName">Username</StyledInputLabel>
          <SearchInput
            name="userName"
            id="userName"
            placeholder="Username"
            onChange={this.props.authInput}
            value={this.props.auth.userName}
          />
          <StyledInputLabel htmlFor="password">Password</StyledInputLabel>
          <SearchInput
            name="password"
            id="password"
            placeholder="Password"
            onChange={this.props.authInput}
            value={this.props.auth.search}
            type="password"
          />
          <StyledSignupLoginButton
            color="red"
            onClick={this.props.SignupUserNamePass}
          >
            SIGNUP
          </StyledSignupLoginButton>
          <BodyText style={{ justifySelf: "center", paddingTop: "1.5rem" }}>
            &#8212; or &#8212;
          </BodyText>
          <StyledSignupLoginButton
            color="#3B5998"
            onClick={this.props.doFacebookLogin}
          >
            CONTINUE WITH FACEBOOK
          </StyledSignupLoginButton>
          <BodyText style={{ justifySelf: "center" }}>
            Already have an account?{" "}
            <a href="#" onClick={this.toggleShowLogin}>
              <strong>Login</strong>
            </a>
          </BodyText>
        </StyledInputDivSignUp>
        <FilterSearchButton type="button" onClick={this.toggleModal} />
      </StyledInputDivContainer>
    </Fragment>
  );

  _loginModalContent = () => (
    <Fragment>
      <StyledInputDivContainer>
        <StyledInputDiv>
          <StyledHeaderText>Login</StyledHeaderText>
          <BodyText style={{ justifySelf: "center" }}>
            No account?
            <a href="#" onClick={this.toggleShowLogin}>
              {" "}
              Signup here
            </a>
          </BodyText>
          <StyledInputLabel htmlFor="email">Email Address</StyledInputLabel>
          <SearchInput
            name="email"
            id="email"
            placeholder="Email"
            onChange={this.props.authInput}
            value={this.props.auth.email}
          />
          <StyledInputLabel htmlFor="password">Password</StyledInputLabel>
          <SearchInput
            name="password"
            id="password"
            placeholder="Password"
            onChange={this.props.authInput}
            value={this.props.auth.search}
            type="password"
          />
          <StyledSignupLoginButton
            color="red"
            onClick={this.props.LoginUserNamePass}
          >
            LOGIN
          </StyledSignupLoginButton>
          <BodyText style={{ justifySelf: "center", paddingTop: "1.5rem" }}>
            &#8212; or &#8212;
          </BodyText>
          <StyledSignupLoginButton
            color="#3B5998"
            onClick={this.props.doFacebookLogin}
          >
            CONTINUE WITH FACEBOOK
          </StyledSignupLoginButton>
        </StyledInputDiv>
        <FilterSearchButton type="button" onClick={this.toggleModal} />
      </StyledInputDivContainer>
    </Fragment>
  );

  _modalContentsToShow = () => {
    // const { showSignup } = this.props;
    const { showLogin } = this.state;
    if (showLogin) {
      return this._loginModalContent();
    } else {
      return this._defaultModalContents();
    }
  };

  navToHomePage = () => {
    this.props.resetSearchResults();
    this.props.searchInputWholeWord("");
    this.props.searchPerformed(false);
    this.props.showAdvancedData(false);
    navigate("/");
  };

  render() {
    const { auth } = this.props;
    const { modalIsOpen, profilePic } = this.state;
    return (
      <MainHeader>
        <HeaderTextContainer>
          <HeaderText onClick={this.navToHomePage} to="/">
            COOLHAND CUE
          </HeaderText>
        </HeaderTextContainer>
        <StyledIconsDiv>
          {modalIsOpen ? (
            <MagnifyingGlassIcon
              name="fas fa-search"
              onClick={this.toggleModal}
            />
          ) : (
            <UserIconDiv onClick={this.toggleModal} styleProp={profilePic}>
              {!profilePic && <UserIcon name="fas fa-user" />}
            </UserIconDiv>
          )}
        </StyledIconsDiv>
        <ModalComponent
          isOpen={modalIsOpen}
          toggleShowLogin={this.toggleShowLogin}
        >
          {!auth.isLoggedIn ? (
            this._modalContentsToShow()
          ) : this.props.music.modalOpen ? (
            this._modalContentsToShow()
          ) : (
            <Profile closeModal={this.toggleModal} />
          )}
        </ModalComponent>
      </MainHeader>
    );
  }
}
const mapStateToProps = (state) => ({
  auth: state.auth,
  music: state.music,
});

export default connect(
  mapStateToProps,
  {
    authInput,
    SignupUserNamePass,
    LoginUserNamePass,
    doFacebookLogin,
    resetAuthFields,
    modalOpen,
    searchPerformed,
    resetSearchResults,
    searchInputWholeWord,
    showAdvancedData,
  }
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js